import { taskServiceTypeDef } from "../definitions/task-service-type-def";
import gql from "graphql-tag";
import { errorsTypeDef } from "../../errors/errors-type-def";

const createDraftMutation = gql`
  mutation createDraft (
  $damageCategoryId: String!
  $damageTypeId: String!
  $carVin: String
  $carLicensePlate: String
  $carNonstandardLicensePlate: Boolean
  $carYearManufactured: Int
  $carModel: String
  $claimNumber: String
  $claimSettlementTypeId: String
  $clientName: String
  $clientPhone: String
  $clientType: String #person nebo company
  $clientIdentificationCode: String
  $dateOfLoss: Timestamp
  $description: String
  $externalCode: String
  $insuranceCompanyId: String
  $leasingApprovalNumber: String
  $note: String
  $serviceNumber: String
  ) {
    task{
      createDraft(input: {
        damageCategoryId: $damageCategoryId
        damageTypeId: $damageTypeId
        carVin: $carVin
        carLicensePlate: $carLicensePlate
        carNonstandardLicensePlate: $carNonstandardLicensePlate
        carYearManufactured: $carYearManufactured
        carModel: $carModel
        claimNumber: $claimNumber
        claimSettlementTypeId: $claimSettlementTypeId
        clientName: $clientName
        clientPhone: $clientPhone
        clientType: $clientType
        clientIdentificationCode: $clientIdentificationCode
        dateOfLoss: $dateOfLoss
        description: $description
        externalCode: $externalCode
        insuranceCompanyId: $insuranceCompanyId
        leasingApprovalNumber: $leasingApprovalNumber
        note: $note
        serviceNumber: $serviceNumber
      }) {
        output {
          ${taskServiceTypeDef}
        }
        errors {
          ${errorsTypeDef}
        }
      }
    }
  }`;

export default createDraftMutation;
